enum IAbilityOrigin {
  game = 'game',
  questionnaire = 'questionnaire'
}

export default IAbilityOrigin



// WEBPACK FOOTER //
// ./src/data/abitilies/interfaces/IAbilityOrigin.ts